import Link from "next/link";
import ChevronRight from "public/images/icons/chevron-right.svg";

import useSearchWithBreadCrumbs from "@/components/brandRefresh/common/use-search-with-breadcrumbs";
import { useMemo } from "react";
import { containsIgnoreCase } from "utils/new-helper";

const searchFilterCallback = (faqTopics = [], search = "") => {
  return faqTopics.reduce((result, { attributes }) => {
    const { Title, slug, Questions = [] } = attributes;
    const matches = [];

    // Add title if it matches the search
    if (containsIgnoreCase(Title, search)) {
      matches.push({ Question: Title, slug, id: slug, excludeParams: true });
    }

    // Add matching questions
    Questions.forEach(({ Question, Answer, id }) => {
      if (
        containsIgnoreCase(Question, search) ||
        containsIgnoreCase(Answer, search)
      ) {
        matches.push({ Question, Answer, slug, id, excludeParams: false });
      }
    });

    return result.concat(matches);
  }, []);
};

const FAQTopicView = ({ faqTopics }) => {
  const breadcrumbTree = useMemo(
    () => [
      {
        title: "Help & Support",
        url: "/help",
        children: [
          {
            title: "FAQs",
            url: "/help/faq",
            children: faqTopics.map(({ attributes }) => ({
              title: attributes.Title,
              url: `/help/faq/${attributes.slug}`,
            })),
          },
        ],
      },
    ],
    [faqTopics],
  );
  const { renderSearchView } = useSearchWithBreadCrumbs({
    breadcrumbTree,
    defaultValues: faqTopics,
    searchFilterCallback,
  });

  return (
    <>
      {renderSearchView()}
      <div className="flex flex-col gap-4">
        {faqTopics.map((v, i) => (
          <Link
            className="bg-onmoPurple-50 p-6 lg:px-10 py-6 text-onmoPrimary rounded-xl text-base lg:text-xl font-medium"
            key={v.attributes.Title}
            href={`faq/${v.attributes.slug}`}
          >
            <p className="flex w-full justify-between items-center">
              <span>{v.attributes.Title} </span>
              <span className="h-6 w-6">
                <ChevronRight />
              </span>
            </p>
          </Link>
        ))}
      </div>
    </>
  );
};

export default FAQTopicView;
